import(/* webpackMode: "eager" */ "/app/apps/about/src/app/global-error.tsx");
